import { useEffect, useRef } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Navigate, useLocation } from "react-router-dom";
import { login } from "../auth/msal";

interface Props {
  children: React.ReactNode;
}

export function RequireAuth({ children }: Props) {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const location = useLocation();
  const redirected = useRef(false);

  useEffect(() => {
    // Do nothing while MSAL is handling a redirect (login response, token
    // refresh, logout). Only fire login when we're idle and unauthenticated.
    if (inProgress !== "none") return;
    if (isAuthenticated) return;
    if (redirected.current) return;
    redirected.current = true;
    void login(location.pathname + location.search);
  }, [isAuthenticated, inProgress, location]);

  if (inProgress !== "none") {
    return <FullScreenLoader label="Sessione in corso…" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}

function FullScreenLoader({ label }: { label: string }) {
  return (
    <div className="centered">
      <div className="login-card">
        <div className="login-card__mark" aria-hidden="true" />
        <h1>{label}</h1>
        <p>Verifica della sessione presso il sistema SSO.</p>
        <div className="skeleton skeleton--line" />
        <div className="skeleton skeleton--line" style={{ width: "70%" }} />
      </div>
    </div>
  );
}
